// src/utils/validationRules.js

export const required = (value) =>
    value ? null : "Este campo é obrigatório";

export const isFile = (value) =>
    value instanceof File ? null : "Envie um arquivo válido";

export const isDate = (value) =>
    !value || isNaN(new Date(value).getTime()) ? "Data inválida" : null;
